import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import styles from '../contents.module.css';
import { setStyles } from 'helpers/setStyles.js';
import { getCategoryIcon } from './categoryIcons';

const level2 = props => {
    const contentTypeId = get(props, 'entity.sys.contentType.sys.id');
    const icon = props.icon || getCategoryIcon(contentTypeId);

    return (
        <div style={{ margin: '0 0 32px' }}>
            <div style={{ marginBottom: '16px' }}>
                <div className={styles['h2-level-wrapper']}>
                    {icon && (
                        <div className={styles['h2-level-icon']}>
                            {icon}
                        </div>
                    )}
                    <h2 className={setStyles(styles['h2-level'], styles['h2-level-printable'])}>{props.title}</h2>
                </div>
            </div>
            {props.children}
        </div>
    );
};
level2.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
    icon: PropTypes.node,
    entity: PropTypes.object,
};

export default level2;
